<template>
    <div class="applications">
        <VHeader page="Applications"/>
        <div class="applications__body">
            <component
                :is="currentPage"
                :cards="cards"
                :is-edit-mode="isEditMode"
                :is-loaded="isLoaded"
                :app="app"
                @addApp="addApp"
                @editApp="editApp"
                @returnToAllApps="returnToAllApps"
                @saveChanges="saveChanges"
            />
        </div>
    </div>
</template>

<script>
    import Card from './Applications/AllApplications/Card';
    import AllApplications from './Applications/AllApplications';
    import Application from './Applications/Application';
    import apiApps from '../api/apiApps';
    import {eventBus} from '@/main';
    import {deleteProjectByBundleId, addProject, updateProjectByBundleId, getUser} from '../api/apiServices';
    import cookieLocalStorage from '../helpers/dataStorage';
    
    export default {
        name: 'Applications',
        components: {Card},
        data() {
            return {
                currentPage: AllApplications,
                isEditMode: false,
                app: {},
                currentCardIndex: 0,
                currentAppIndex: 0,
                isLoaded: false,
                cards: [
                    {
                        title: 'Application list:',
                        apps: [],
                    },
                ],
            };
        },
        created() {
            this.getData();
            eventBus.$on('VNotification-Delete-application', this.deleteApp);
        },
        beforeDestroy() {
            eventBus.$off('VNotification-Delete-application', this.deleteUser);
        },
        methods: {
            getData() {
                apiApps.getApps().then((response) => {
                    this.isLoaded = true;
                    const apps = response.data.map(app => {
                        if (app.smallbiz_history && app.smallbiz_history.length > 0) {
                            app.smallbiz_history = app.smallbiz_history.map(entry => ({
                                start: entry.date_start,
                                end: entry.date_end,
                            }));
                        }
                        return app;
                    });
                    window.savedRequests.apps = response.data;
                    this.cards.forEach((card) => {
                        card.apps = _.cloneDeep(apps);
                    });
                }).catch((error) => {
                    this.$toastr.e(error.response.data.error);
                });
            },
            addApp(cardIndex) {
                this.currentCardIndex = cardIndex;
                this.isEditMode = false;
                this.clearApp();
                this.changePage(Application);
            },
            editApp(app, appIndex, cardIndex) {
                this.app = _.cloneDeep(app);
                this.currentCardIndex = cardIndex;
                this.currentAppIndex = appIndex;
                this.isEditMode = true;
                this.changePage(Application);
            },
            clearApp() {
                this.app = {
                    bundle_id: '',
                    title: '',
                    url: '',
                    logo_large: '',
                    logo_small: '',
                    secret: '',
                    key: {
                        key_id: '',
                        issuer_id: '',
                        private_key: '',
                    },
                    smallbiz: false,
                    smallbiz_history: [],
                };
            },
            returnToAllApps() {
                this.changePage(AllApplications);
            },
            changePage(page) {
                this.$toastr.removeByType('error');
                this.currentPage = page;
            },
            saveChanges(app) {
                const sendObj = {
                    title: app.title,
                    bundle_id: app.bundle_id,
                    secret: app.secret,
                    smallbiz: app.smallbiz,
                    logo_large: app.logo_large,
                    logo_small: app.logo_small,
                    key: app.key,
                    os: app.os,
                    smallbiz_history: app.smallbiz_history || [],
                };
                
                if (this.isEditMode) {
                    delete sendObj.logo_large;
                    delete sendObj.logo_small;
                    apiApps.updateApp(sendObj, app.id).then(() => {
                        const appIndex = this.cards[this.currentCardIndex].apps.findIndex((allApp) => allApp.id === app.id);
                        this.cards[this.currentCardIndex].apps.splice(appIndex, 1, app);
                        this.app = _.cloneDeep(app);
                        const newProject = _.cloneDeep(app);
                        newProject.id = '';
                        delete newProject.secret;
                        delete newProject.smallbiz;
                        delete newProject.createdAt;
                        delete newProject.store_id;
                        updateProjectByBundleId(newProject);
                    }).catch((error) => {
                        this.$toastr.longError(
                            `Update error : ${error.response.data.error}`,
                        );
                    });
                } else {
                    const newProject = _.cloneDeep(sendObj);
                    newProject.id = '';
                    newProject.org_name = getUser().org_name;
                    delete newProject.secret;
                    delete newProject.smallbiz;
                    apiApps.addApp(sendObj).then(() => {
                        const appImageId = +cookieLocalStorage.get('currentApplicationImageId') || 0;
                        cookieLocalStorage.set('currentApplicationImageId', appImageId < 4 ? appImageId + 1 : 0, '90D');
                        addProject(newProject);
                        this.getData();
                    }).catch((error) => {
                        this.$toastr.longError(
                            `Save error : ${error.response.data.error}`,
                        );
                    });
                }
                this.changePage(AllApplications);
            },
            deleteApp(deleteApp) {
                const sendObj = {
                    id: deleteApp.id,
                };
                apiApps.deleteApp(sendObj).then(() => {
                    this.cards[this.currentCardIndex].apps = this.cards[this.currentCardIndex].apps.filter((app) => app.id !== deleteApp.id);
                    deleteProjectByBundleId(deleteApp.bundle_id);
                }).catch((error) => {
                    this.$toastr.longError(
                        `Delete error : ${error.response.data.error}`,
                    );
                });
                
                this.changePage(AllApplications);
            },
        },
    };
</script>

<style
    scoped
    lang="scss"
>
    .applications {
        &__body {
            padding-left: 30px;
            padding-top: 7px;
        }
    }
</style>
